import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CONVERSATIONS } from "@/constants/testIds";

// Letras que entran en un SMS comun (GSM-7). Cualquier otra (tildes como á, í, ó, ú, o emojis) pasa el mensaje a 70 caracteres por SMS.
const GSM = /^[\n\r\x20-\x7E¡¿ñÑüÜéÉèùìòÇØøÅåÆæßÄÖäöà£¥§€]*$/;

export function smsLength(text) {
  const unicode = !GSM.test(text);
  const single = unicode ? 70 : 160;
  const part = unicode ? 67 : 153;
  const parts = text.length === 0 ? 0 : text.length <= single ? 1 : Math.ceil(text.length / part);
  return { chars: text.length, parts, unicode };
}

// Fix AP (2026-10-23): caja para responder por SMS (solo texto).
export default function SmsComposer({ draft, setDraft, sending, onSend, optedOut, compact, isTouch, leading = null }) {
  if (optedOut) {
    return (
      <p className="text-xs text-muted-foreground text-center" data-testid={CONVERSATIONS.smsOptOutNotice}>
        Esta persona respondió STOP: no se le puede escribir por SMS hasta que mande START. Podés escribirle por WhatsApp.
      </p>
    );
  }
  const { chars, parts, unicode } = smsLength(draft);
  return (
    <div className="space-y-1.5" data-testid={CONVERSATIONS.smsComposer}>
      <div className={`flex items-end gap-2 ${compact ? "[&>button]:h-11 [&>button]:min-w-11" : ""}`}>
        {leading}
        <Textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Escribí el SMS..."
          rows={compact ? 1 : 2}
          maxLength={1500}
          className="min-h-[44px] max-h-32 resize-none"
          data-testid={CONVERSATIONS.smsInput}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey && !(compact && isTouch)) { e.preventDefault(); onSend(); } }}
        />
        <Button onClick={onSend} disabled={sending || !draft.trim()} className="bg-brand hover:bg-brand-hover text-white shrink-0" aria-label="Enviar SMS" data-testid={CONVERSATIONS.smsSendButton}>
          <Send className="w-4 h-4" />
        </Button>
      </div>
      <p className="text-[11px] text-muted-foreground">
        Por SMS (solo texto, sin ventana de 24 horas).{chars > 0 ? ` ${chars} caracteres · ${parts} SMS${unicode ? ". Las tildes (á, í, ó, ú) y los emojis acortan cada SMS a 70 caracteres." : "."}` : ""}
      </p>
    </div>
  );
}
